import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.protokoll-excel';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleProtokollExcelEffects {

    ProtokollExcel$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PROTOKOLL_EXCEL),
        mergeMap((x: ac.GetProtokollExcelAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getProtokollExcel(x.alte_daten_entfernen).pipe(
                map((result: any) => {
                    return new ac.GetProtokollExcelErfolgreichAction(x.alte_daten_entfernen, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetProtokollExcelFehlerAction(error, x.alte_daten_entfernen, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleQueryService);
        }
        return this.service;
    }
}
